
export class CountryDetectionVO {

    /**
     * Constructs a CountryDetectionVO that can be supplied to GGSCountryDetector.detectCountry().
     * This contains all the user-specific information that the CountryDetector needs, so that it doesn't have to query this information by itself (like the timezone).
     * @param browserLanguage the user's browser language
     * @param timezoneOffset the user's timezone in UTC (should be between -12 and +12, daylight savings time should not be included)
     * @param countryCodeFromNetworkCookie optional, country code from the network cookie
     * @param countryCodeFromQueryString optional, country code given by the embedding/referring page (e.g. a landing page)
     * @param countryByPresetInstance optional, country code dictated by the instance (some partners want to dictate the country).
     * @param zoneIdFromFriendInviteCode optional, country code dictated by the friend invite code.
     * @param countryByDefaultInstance optional, country code dictated by the default instance from network settings.
     * @param fakeGeoIpResponse if this is set, the CountryDetector takes this as geoIp response without actually requesting one
     * @param alsoDetectUnavailableCountries if this is true, the CountryDetector uses the list of all countries for detection; if false, it uses only the list of available countries
     *
     * @see CountryDetector
     */
    constructor(
        public readonly browserLanguage: string,
        public readonly timezoneOffset: number,
        public readonly countryCodeFromNetworkCookie: string,
        public readonly countryCodeFromQueryString: string,
        public readonly countryByPresetInstance: string,
        public readonly zoneIdFromFriendInviteCode: string,
        public readonly countryByDefaultInstance: string,
        public readonly fakeGeoIpResponse: string,
        public readonly alsoDetectUnavailableCountries: boolean
    ) {
    }

    public toString(): string {
        return [
            "browserLanguage: " + this.browserLanguage,
            "timezoneOffset: " + this.timezoneOffset,
            "countryCodeFromNetworkCookie: " + this.countryCodeFromNetworkCookie,
            "countryCodeFromQueryString: " + this.countryCodeFromQueryString,
            "countryByInstance: " + this.countryByPresetInstance,
            "zoneIdFromFriendInviteCode: " + this.zoneIdFromFriendInviteCode,
            "countryByDefaultInstance: " + this.countryByDefaultInstance,
            "fakeGeoIpResponse: " + this.fakeGeoIpResponse,
            "alsoDetectUnavailableCountries: " + this.alsoDetectUnavailableCountries
        ].join(", ");
    }
}
